/**
 * Holds information about options for form inputs.
 */
export class FormOption {
  /**
   * The label that is displayed on the client end.
   */
  label: string;

  /**
   * The value of the option.
   * Defaults to the passed label if no key is provided in the constructor.
   */
  value: string;

  constructor(label: string, value?: string) {
    this.label = label;
    this.value = value ? value : label;
  }
}
